import React from 'react'

function Bookmarks() {
  return (
    <div className="  ">
      Bookmarks
    </div>
  );
}

export default Bookmarks